import {WinPresentationController} from "../WinPresentationController";
import {WalkOfShame} from "../../WalkOfShame";
import {TimelineLite} from "gsap";
import {WalkOfShameSound} from "../../sound/WalkOfShameSound";

export class MToWildController extends WinPresentationController {
    private _mainTimeline: TimelineLite | null;

    constructor() {
        super("MToWildController", true);
    }

    protected hasWin(): boolean {
        return WalkOfShame.model.parsedGameData.mToWildFeature.length > 0;
    }

    protected async createWinAnimation(): Promise<void> {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            WalkOfShameSound.soundPlayer.playTrack({
                name: WalkOfShameSound.WILD_TRANSFORM
            });
        });
        tl.add(WalkOfShame.mToWild.getAnimation());
        this._mainTimeline = tl;
        await tl;
        this._mainTimeline = null;
    }

    protected skip(): void {
        this._mainTimeline?.progress(1);
        WalkOfShame.mToWild.skip();
    }
}